import { Dispatch, SetStateAction } from "react";
import { AttendanceChatFilterProps } from ".";
import { AttendanceChatProps } from "../chats-context/types";
import { Toast } from "components/toast";
import { apiJWT } from "api/api-jwt";

export function checkIsValidAttendance(
  filters: AttendanceChatFilterProps,
  currAtendimento: AttendanceChatProps,
) {
  let result = true;
  if (Object.keys(filters).includes("convenio")) {
    result = currAtendimento.convenio === filters.convenio;
  }
  if (result && Object.keys(filters).includes("tabulacoes")) {
    result = !!filters.tabulacoes?.includes(currAtendimento.tabulacao!);
  }
  if (result && Object.keys(filters).includes("userIds")) {
    result = !!filters.userIds?.includes(currAtendimento.userId!);
  }
  if (result && Object.keys(filters).includes("onlyUnreadMessage")) {
    result = currAtendimento.unreadMessage === filters.onlyUnreadMessage;
  }
  if (result && Object.keys(filters).includes("fromDataCriacao")) {
    result =
      !!filters.fromDataCriacao &&
      !!currAtendimento.dataCriacao &&
      currAtendimento.dataCriacao >=
        new Date(filters.fromDataCriacao + "T00:00").getTime();
  }
  if (result && Object.keys(filters).includes("toDataCriacao")) {
    result =
      !!filters.toDataCriacao &&
      !!currAtendimento.dataCriacao &&
      currAtendimento.dataCriacao <
        new Date(filters.toDataCriacao + "T00:00").getTime() +
          24 * 60 * 60 * 1000;
  }
  if (result && Object.keys(filters).includes("etapas")) {
    result = !!filters.etapas?.includes(currAtendimento.etapa!);
  }
  if (result && Object.keys(filters).includes("resultado")) {
    result = currAtendimento.resultado === filters.resultado;
  } else if (result) {
    result = !currAtendimento.resultado;
  }
  if (result && Object.keys(filters).includes("tagIds")) {
    result =
      !!currAtendimento.tagIds &&
      currAtendimento.tagIds.some((tagId) => filters.tagIds?.includes(tagId));
  }
  return result;
}

export const getUsers = async ({
  setLoading,
  setUsers,
}: {
  setLoading?: Dispatch<SetStateAction<boolean>>;
  setUsers: Dispatch<
    SetStateAction<{ name: string; value: number; isVendeAI: boolean }[]>
  >;
}) => {
  setLoading?.(true);
  try {
    const { data } = await apiJWT.get("/usuarios/possible-transfer-attendance");
    setUsers(
      data.map((user: any) => ({
        name: user.name,
        value: user.id,
        isVendeAI: user.vendeAI,
      })),
    );
  } catch (e) {
    Toast({ title: "Erro ao carregar usuários!", status: "error" });
  } finally {
    setLoading?.(false);
  }
};
